/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ObjectionPositionReductionV1Dto } from './ObjectionPositionReductionV1Dto';
export type PatchObjectionPositionBulkItemV1Dto = {
  /**
   * The current version of the contract.
   */
  version: number;
  /**
   * Comment specific to this line item within the objection
   */
  comment?: string;
  status?: PatchObjectionPositionBulkItemV1Dto.status;
  /**
   * The green reduction contribution
   */
  reductionGreen?: ObjectionPositionReductionV1Dto;
  /**
   * The yellow reduction contribution
   */
  reductionYellow?: ObjectionPositionReductionV1Dto;
  /**
   * The red reduction contribution
   */
  reductionRed?: ObjectionPositionReductionV1Dto;
  /**
   * ID of the position to update
   */
  id: string;
};
export namespace PatchObjectionPositionBulkItemV1Dto {
  export enum status {
    UNCLEAR = 'Unclear',
    IN_CLARIFICATION = 'InClarification',
    CLARIFIED = 'Clarified',
  }
}
